/* globals WebSocket */

// Export native window.WebSocket on browsers
module.exports = WebSocket;
